import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = {
  id: "scenario-dashboard",
  class: "card-body"
}
const _hoisted_3 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_4 = {
  key: 1,
  class: "row mx-auto my-3"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 text-center" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_9 = {
  key: 1,
  class: "row mx-auto my-3"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 text-center" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rubric_list_item = _resolveComponent("rubric-list-item")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_tab = _resolveComponent("tab")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_tabs, {
              options: { useUrlFragment: false },
              "nav-class": "nav nav-pills",
              "nav-item-class": "nav-item col-md-4 col-sm-6 col-xs-12 text-center mb-4",
              "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
              "nav-item-link-active-class": "active"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_tab, {
                  prefix: "<h2 class='mt-2'>",
                  suffix: " / <i class='fas fa-edit text-primary'></i></h2>",
                  name: "Rubric Drafts"
                }, {
                  default: _withCtx(() => [
                    _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-12 scenario-list-header" }, "Rubric Drafts", -1)),
                    (Object.keys(_ctx.draft_rubrics).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft_rubrics.slice(_ctx.draft_page_start,_ctx.draft_page_end), (rubric) => {
                            return (_openBlock(), _createBlock(_component_rubric_list_item, {
                              key: rubric.id,
                              rubric: rubric
                            }, null, 8, ["rubric"]))
                          }), 128)),
                          (Object.keys(_ctx.draft_rubrics).length > 10)
                            ? (_openBlock(), _createBlock(_component_pagination, {
                                key: 0,
                                class: "col-12",
                                items: _ctx.draft_rubrics,
                                page_start: _ctx.draft_page_start,
                                page_end: _ctx.draft_page_end,
                                onNextPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextPage('draft'))),
                                onPreviousPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previousPage('draft'))),
                                label: 'Rubrics'
                              }, null, 8, ["items", "page_start", "page_end"]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[6] || (_cache[6] = [
                          _createElementVNode("div", { class: "col-12 text-center" }, [
                            _createElementVNode("p", null, "There are currently no rubric drafts.")
                          ], -1)
                        ]))),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
                          disabled: _ctx.loading
                        }, _cache[7] || (_cache[7] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                          _createTextVNode(),
                          _createElementVNode("span", { class: "d-none d-md-inline" }, "CREATE A NEW RUBRIC", -1)
                        ]), 8, _hoisted_7)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_tab, {
                  prefix: "<h2 class='mt-2'>",
                  suffix: " / <i class='fas fa-clipboard-list text-primary'></i></h2>",
                  name: "Published Rubrics"
                }, {
                  default: _withCtx(() => [
                    _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-12 scenario-list-header" }, "Published Rubrics", -1)),
                    (Object.keys(_ctx.published_rubrics).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.published_rubrics.slice(_ctx.published_page_start,_ctx.published_page_end), (rubric) => {
                            return (_openBlock(), _createBlock(_component_rubric_list_item, {
                              key: rubric.id,
                              rubric: rubric
                            }, null, 8, ["rubric"]))
                          }), 128)),
                          (Object.keys(_ctx.published_rubrics).length > 10)
                            ? (_openBlock(), _createBlock(_component_pagination, {
                                key: 0,
                                class: "col-12",
                                items: _ctx.published_rubrics,
                                page_start: _ctx.published_page_start,
                                page_end: _ctx.published_page_end,
                                onNextPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nextPage('published'))),
                                onPreviousPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.previousPage('published'))),
                                label: 'Rubrics'
                              }, null, 8, ["items", "page_start", "page_end"]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[10] || (_cache[10] = [
                          _createElementVNode("div", { class: "col-12 text-center" }, [
                            _createElementVNode("p", null, "There are currently no published rubrics.")
                          ], -1)
                        ]))),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
                          disabled: _ctx.loading
                        }, _cache[11] || (_cache[11] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                          _createTextVNode(),
                          _createElementVNode("span", { class: "d-none d-md-inline" }, "CREATE A NEW RUBRIC", -1)
                        ]), 8, _hoisted_12)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}